import { CSSProperties } from 'react';

import styled, { css } from 'styled-components';
import Drawer from 'antd/es/drawer';
import Input from 'antd/es/input';

export const StyledDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      overflow: auto;
      padding: 0px;
    }

    .setur-drawer-header {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${({ theme }) => theme.palette.grey1100};
    }

    .setur-drawer-content-wrapper {
      height: 100% !important;
    }

    .setur-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
    }

    .setur-drawer-title {
      display: flex;
      font-family: ${({ theme }) => theme.fonts.main};
      font-weight: 600;
      color: ${({ theme }) => theme.palette.white};
    }

    .setur-drawer-close {
      padding: 0px;
      margin-inline-end: 0px;
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
  }
`;

export const ResponsiveSearchDrawerItemContent = styled.div<{
  hasError: boolean;
  height?: CSSProperties['height'];
}>`
  display: flex;
  align-items: center;
  padding: 16px 12px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.palette.inputBorderColor};
  border-radius: 4px;
  width: 100%;

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}

  &:is(:focus-within, :hover) {
    border: 1px solid ${({ theme }) => theme.palette.black};
  }

  &:focus {
    box-shadow: none;
  }
  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.errorColor};
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97);

      @keyframes shake {
        10%,
        90% {
          transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
          transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
          transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
          transform: translate3d(4px, 0, 0);
        }
      }
    `}
`;

export const ResponsiveSearchDrawerItemText = styled.div<{
  isEmpty: boolean;
}>`
  flex: 1;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  margin-left: 8px;
  text-overflow: ellipsis; /* enables ellipsis */
  white-space: nowrap; /* keeps the text in a single line */
  overflow: hidden; /* keeps the element from overflowing its parent */

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      opacity: 0.5;
    `}
`;

export const ResponsiveSearchDrawerItemTitle = styled.span`
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.main};
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const StyledInput = styled(Input)`
  &&& {
    width: 150px;
    height: 56px;
    border-radius: 4px;
    margin-right: 3px;
    border-width: 1px solid ${({ theme }) => theme.palette.grey200};

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
      width: 100%;
    }
  }
`;
